import React from 'react'
import styled from 'styled-components'
import notify_prefs_wrapperStyles from './notify_prefs_wrapper.styles'

const apAtomName = {ap_atom_name: 'apNotifyPrefsWrapperAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${notify_prefs_wrapperStyles}
`

const NotifyPrefsWrapperAtom: React.FC = function ({children}) {
  return <StyledWrapper {...apAtomName}>{children}</StyledWrapper>
}

export default NotifyPrefsWrapperAtom
